import React, {useState} from 'react';

const Tile = (props) => {
    const {
        file,
        onRemove,
    } = props;

    return (
        <div className={"tile-file"}>

        </div>
    );
}

export default Tile;
